export const onReadyTimeout = 5000;

export const drawerTimeout = 1500;

export const animationPlayOpeningActionTimeout = 200;

export const animationPlayResizedActionTimeout = 150;

export const debounceTimeout = 100;

export const focusTimeout = 100;

export const focusTimeoutLong = 250;
